import { temAcesso } from '@/shared/auth/temAcesso'

const Contratacoes = () => import('./Contratacoes.vue')
const Contratacao = () => import('./Contratacao.vue')
const Entrega = () => import('./../entregas/Entrega.vue')
const Rateios = () => import('./../rateios/Rateios.vue')

export default {
    path: 'contratacoes',
    name: 'Uabs_Contratacoes',
    component: Contratacoes,
    beforeEnter: (to, from, next) => {
        if (temAcesso('CRED-UABS-CONT-00')) {
            next()
        }
    },
    children: [
        {
            path: ':contratacaoId',
            name: 'Uabs_Contratacoes_Detalhar',
            component: Contratacao,
            beforeEnter: (to, from, next) => {
                if (temAcesso('CRED-UABS-CONT-01')) {
                    next()
                }
            },
            children: [
                {
                    path: 'entregas/:entregaId',
                    name: 'Uabs_Entregas_Detalhar',
                    component: Entrega,
                    beforeEnter: (to, from, next) => {
                        if (temAcesso('CRED-UABS-ENTR-01')) {
                            next()
                        }
                    }
                },
                {
                    path: 'rateios',
                    name: 'Uabs_Contratacoes_Rateios',
                    component: Rateios,
                    beforeEnter: (to, from, next) => {
                        if (temAcesso('CRED-UABS-RAT-00')) {
                            next()
                        }
                    }
                }
            ]
        }
    ]
}
